// container with style and takes children (react components)
import React from 'react';
import {
  makeStyles, Container,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
    padding: theme.spacing(3),
    margin: theme.spacing(0),
  },
}));

const ShadowBox = ({
  children,
}) => {
  const classes = useStyles();

  return (
    <>
      <Container className={classes.root}>
        {children}
      </Container>
    </>

  );
};

export default ShadowBox;
